import React from 'react';
import { Link } from 'react-router-dom';

import "./styles.css";
import '../../global.css';
import Header from '../../components/Header';
import HandleMovimentacao from '../../components/data_mov';
import Footer from '../../components/Footer';

function Tabela(){
    return (
        <>
            <Header />

            <main>
                <div className="title">
                    <h1>Fluxo de Caixa</h1>
                    <Link to="/create-mov">Nova Movimentação</Link>
                </div>

                <HandleMovimentacao/>               
            </main>

            <Footer/>
        </>
    );
}

export default Tabela;